export const SET_SELECTED_TERMINAL = "SET_SELECTED_TERMINAL";
export const SET_SELECTED_TRANSACTION_TYPES = "SET_SELECTED_TRANSACTION_TYPES";
export const SET_TRANSACTION_DATES = "SET_TRANSACTION_DATES";
export const SET_TRANSACTION_VOLUME_DATES = "SET_TRANSACTION_VOLUME_DATES";
export const SET_TRANSACTION_STATS_TYPES = "SET_TRANSACTION_STATS_TYPES";
export const GET_TERMINAL_SUMMARY = "GET_TERMINAL_SUMMARY";
export const GET_TERMINAL_SUMMARY_SUCCESS = "GET_TERMINAL_SUMMARY_SUCCESS";
export const GET_TERMINAL_SUMMARY_FAIL = "GET_TERMINAL_SUMMARY_FAIL";
export const GET_TERMINAL_ACTIVITY = "GET_TERMINAL_ACTIVITY";
export const GET_TERMINAL_ACTIVITY_SUCCESS = "GET_TERMINAL_ACTIVITY_SUCCESS";
export const GET_TERMINAL_ACTIVITY_FAIL = "GET_TERMINAL_ACTIVITY_FAIL";
export const GET_TRANSACTION_TYPE_STATS = "GET_TRANSACTION_TYPE_STATS";
export const GET_TRANSACTION_TYPE_STATS_SUCCESS =
  "GET_TRANSACTION_TYPE_STATS_SUCCESS";
export const GET_TRANSACTION_TYPE_STATS_FAIL =
  "GET_TRANSACTION_TYPE_STATS_FAIL";
export const GET_TRANSACTION_BREAKDOWN_SUCCESS =
  "GET_TRANSACTION_BREAKDOWN_SUCCESS";
export const GET_TRANSACTION_BREAKDOWN = "GET_TRANSACTION_BREAKDOWN";
export const GET_TRANSACTION_BREAKDOWN_FAIL = "GET_TRANSACTION_BREAKDOWN_FAIL";
export const SET_CURRENT_AGENT = "SET_CURRENT_AGENT";
export const GET_TRANSACTION_STATUS_STATS = "GET_TRANSACTION_STATUS_STATS";
export const GET_TRANSACTION_STATUS_STATS_FAIL =
  "GET_TRANSACTION_STATUS_STATS_FAIL";
export const GET_TRANSACTION_STATUS_STATS_SUCCESS =
  "GET_TRANSACTION_STATUS_STATS_SUCCESS";
export const GET_REGION_STATS = "GET_REGION_STATS";
export const GET_REGION_STATS_SUCCESS = "GET_REGION_STATS_SUCCESS";
export const GET_REGION_STATS_FAIL = "GET_REGION_STATS_FAIL";
